import { useDispatch, useSelector } from 'react-redux';
import type { AppDispatch, RootState } from './store';

/**
 * Pre-typed hooks. Components should always use these instead of the raw react-redux ones —
 * they carry `RootState` and the thunk-aware dispatch type, so selectors and dispatches are
 * checked rather than `any`.
 */
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
